import { useEffect } from 'react';
import { ISlideOrSlideGroup } from '@/components/admin/SlideShow/stores/useSlideShowStore';

interface UseInitialSlideArgs {
  isSlideLocked: (slide: ISlideOrSlideGroup) => boolean;
  onSelectSlide: (slide: ISlideOrSlideGroup) => void;
  selectedSlide: ISlideOrSlideGroup | null;
  slides: ISlideOrSlideGroup[];
  startingSlide: number;
}

// AIDEV-NOTE: PLAT-17332 — Picks a default slide only while none is selected. `slides` re-emits
// when the slideshow query re-resolves; without the guard that would reset to slide 1 and clobber
// teacher-paced-mode sync (or the student's own navigation).
const useInitialSlide = ({
  isSlideLocked,
  onSelectSlide,
  selectedSlide,
  slides,
  startingSlide,
}: UseInitialSlideArgs): void => {
  useEffect(() => {
    if (slides.length === 0 || selectedSlide) return;

    const matchedSlide = slides.find(slide => (
      slide.position === startingSlide || parseInt(String(slide.id), 10) === startingSlide
    ));

    if (startingSlide !== 0 && matchedSlide) {
      // First slide at/before the starting slide that isn't locked.
      const unlocked = [...slides].reverse()
        .slice(slides.length - matchedSlide.position)
        .find(slide => !isSlideLocked(slide));
      onSelectSlide(unlocked ?? slides[0]);
    } else {
      onSelectSlide(slides[0]);
    }
  }, [selectedSlide, slides]);
};

export default useInitialSlide;
